import React, { useState, useRef } from 'react';
import './App.css';

const MOCK_USER = {
  email: 'demo@hargrove.com',
  password: 'demo123',
  name: 'Alex Morgan',
  role: 'Pre-Sales Engineer',
  company: 'Hargrove Construction Group',
};

const MOCK_PROJECTS = [
  { id: 'HCG-001', name: 'Austin Medical Center', location: 'Austin, TX', status: 'Active' },
  { id: 'HCG-002', name: 'Denver Tech Campus', location: 'Denver, CO', status: 'Active' },
  { id: 'HCG-003', name: 'Seattle Waterfront Tower', location: 'Seattle, WA', status: 'Active' },
  { id: 'HCG-004', name: 'Chicago Logistics Hub', location: 'Chicago, IL', status: 'Inactive' },
];

const RFI_TYPES = [
  'Design Clarification','Structural Query','MEP Coordination','Site Condition',
  'Material Substitution','Code Compliance','Schedule Impact','Scope Clarification',
];

const SIDEBAR_MODULES = [
  { id: 'schedule', name: 'Schedule', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>), items: [{ id: 'schedule', name: 'Planner' }] },
  { id: 'documents', name: 'Documents', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>), items: [{ id: 'rfi', name: 'RFI' }, { id: 'submittals', name: 'Submittals' }, { id: 'plansheets', name: 'Plan Sheets' }] },
  { id: 'finance', name: 'Finance', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>), items: [{ id: 'contract', name: 'Contract' }, { id: 'budget', name: 'Budget' }] },
  { id: 'quality', name: 'Quality', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>), items: [{ id: 'checklists', name: 'Checklists' }, { id: 'punchlist', name: 'Punchlist' }] },
  { id: 'field', name: 'Field', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>), items: [{ id: 'field', name: 'Field Reports' }] },
  { id: 'payroll', name: 'Payroll', icon: (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>), items: [{ id: 'payroll', name: 'Payroll' }] },
];

const MODULE_COLUMNS = {
  schedule: ['S.No','Task Name','Start Date','End Date','Duration','Predecessors','Planned Hours','Planned Quantity','UOM','Assigned To'],
  rfi: ['RFI Title','RFI Type','Question'],
  submittals: ['Submittal No','Description','Spec Section','Submitted By','Date Submitted','Due Date','Status','Reviewer'],
  plansheets: ['Sheet No','Sheet Name','Discipline','Revision','Date Issued','Issued By','Status'],
  contract: ['Contract No','Contractor','Scope','Contract Value','Start Date','End Date','Status'],
  budget: ['Cost Code','Description','Budgeted Amount','Committed Cost','Actual Cost','Variance','Status'],
  checklists: ['Checklist No','Description','Location','Assigned To','Due Date','Status','Comments'],
  punchlist: ['Item No','Description','Location','Assigned To','Due Date','Priority','Status'],
  field: ['Report No','Date','Weather','Manpower','Equipment','Work Performed','Issues'],
  payroll: ['Employee ID','Name','Trade','Regular Hours','OT Hours','Rate','Total Pay'],
};

const EXAMPLE_PROMPTS = {
  schedule: ['Generate a schedule for foundation work with 10 tasks','Create MEP installation schedule with 3 phases'],
  rfi: ['We need clarification on the structural steel connection details at grid line B-4','The MEP drawings show a conflict with the sprinkler layout on Level 3','Request clarification on concrete mix design for the podium slab'],
  submittals: ['Generate submittals for concrete mix designs','Create submittals for steel fabrication shop drawings'],
  plansheets: ['Generate structural drawing sheet list','Create architectural plan sheet register'],
  contract: ['Generate contracts for major subcontractors','Create contracts for MEP and structural trades'],
  budget: ['Generate budget for a hospital construction project','Create cost breakdown for structural and MEP work'],
  checklists: ['Generate safety inspection checklists','Create quality control checklists for concrete work'],
  punchlist: ['Generate punchlist items for Level 1 finishes','Create MEP punchlist items'],
  field: ['Generate field reports for last week','Create daily field reports for foundation phase'],
  payroll: ['Generate payroll for construction crew of 20','Create weekly payroll for MEP trades'],
};

async function callAI(prompt) {
  const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer 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' },
    body: JSON.stringify({
      model: 'llama-3.1-8b-instant',
      messages: [
        { role: 'system', content: 'You are a data generator for Linarc, a construction management platform. Always return ONLY valid JSON with no markdown, no backticks, no explanation.' },
        { role: 'user', content: prompt }
      ],
      temperature: 0.7
    })
  });
  const data = await response.json();
  if (data.error) throw new Error(data.error.message);
  return data.choices[0].message.content.trim().replace(/```json|```/g, '').trim();
}

async function mockLinarcAPI(record) {
  await new Promise(res => setTimeout(res, 600 + Math.random() * 400));
  if (Math.random() < 0.08) throw new Error('Connection timeout');
  return { success: true, id: 'RFI-' + Math.floor(Math.random() * 9000 + 1000) };
}

function ModuleCard({ mod, onSelect }) {
  return (
    <div className="module-card">
      <div className="module-card-header">
        <div className="module-card-icon">{mod.icon}</div>
        <h4 className="module-card-title">{mod.name}</h4>
      </div>
      <div className="module-card-items">
        {mod.items.map(item => (
          <div key={item.id} className="module-card-item" onClick={() => onSelect(item.id)}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState('login');
  const [user, setUser] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  if (page === 'login') return <LoginPage onLogin={(u) => { setUser(u); setPage('projects'); }} />;
  if (page === 'projects') return <ProjectsPage user={user} onSelect={(p) => { setSelectedProject(p); setPage('dashboard'); }} />;
  if (page === 'dashboard') return <Dashboard user={user} project={selectedProject} onBack={() => setPage('projects')} />;
}

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleLogin = () => {
    if (email === MOCK_USER.email && password === MOCK_USER.password) { onLogin(MOCK_USER); }
    else { setError('Invalid email or password.'); }
  };
  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card-top">
          <div className="brand-logo">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
          </div>
          <span className="login-card-brand">DataForge</span>
        </div>
        <div className="login-card-divider" />
        <h2 className="login-title">Welcome back</h2>
        <p className="login-sub">Sign in to your workspace</p>
        <div className="login-field">
          <label>Email address</label>
          <input type="email" placeholder="you@company.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>
        <div className="login-field">
          <label>Password</label>
          <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
        </div>
        {error && <p className="login-error">{error}</p>}
        <button className="login-btn" onClick={handleLogin}>Sign in →</button>
        <div className="login-demo-hint"><span>Demo:</span><code>demo@hargrove.com</code> / <code>demo123</code></div>
      </div>
      <p className="login-footer">AI-powered construction data generation · Linarc Integration</p>
    </div>
  );
}

function ProjectsPage({ user, onSelect }) {
  const [showCreate, setShowCreate] = useState(false);
  const [mode, setMode] = useState('ai');
  const [aiPrompt, setAiPrompt] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [form, setForm] = useState({ jobId:'', name:'', location:'', projectType:'', buildingType:'', subtype:'', startDate:'', endDate:'', projectManager:'', sitePhone:'', siteArea:'' });
  const projectTypes = ['Commercial','Residential','Healthcare','Industrial','Infrastructure','Mixed Use'];
  const activeCount = MOCK_PROJECTS.filter(p => p.status === 'Active').length;
  const inactiveCount = MOCK_PROJECTS.filter(p => p.status === 'Inactive').length;

  const generateProjectFromAI = async () => {
    if (!aiPrompt) return;
    setAiLoading(true);
    try {
      const text = await callAI('Based on this project description: "' + aiPrompt + '" return ONLY valid JSON: {"jobId":"HCG-XXX","name":"Project Name","location":"City, State","projectType":"Commercial","buildingType":"Office Tower","subtype":"Class A","startDate":"YYYY-MM-DD","endDate":"YYYY-MM-DD","projectManager":"Full Name","sitePhone":"+1 (XXX) XXX-XXXX","siteArea":"50000"}');
      setForm(JSON.parse(text)); setMode('manual');
    } catch { alert('Error generating. Try again.'); }
    setAiLoading(false);
  };

  const handleCreate = () => {
    if (Object.values(form).some(v => !v)) { alert('All fields required.'); return; }
    onSelect({ id: form.jobId, name: form.name, location: form.location, status: 'Active', ...form });
  };

  return (
    <div className="projects-page">
      <header className="projects-header">
        <div className="projects-logo">
          <div className="brand-logo small"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div>
          <span>DataForge</span>
        </div>
        <div className="projects-user">
          <div className="user-avatar">{user.name[0]}</div>
          <div className="user-info"><span className="user-name">{user.name}</span><span className="user-role">{user.role}</span></div>
          <button className="logout-btn" onClick={() => window.location.reload()}>Sign out</button>
        </div>
      </header>

      <div className="projects-content">
        <div className="projects-top">
          <div><h1 className="projects-title">Projects</h1><p className="projects-sub">{user.company}</p></div>
          <button className="btn-primary" onClick={() => setShowCreate(!showCreate)}>{showCreate ? 'Cancel' : '+ New Project'}</button>
        </div>

        <div className="projects-stats-bar">
          <div className="projects-stat">
            <span className="projects-stat-num">{MOCK_PROJECTS.length}</span>
            <span className="projects-stat-label">Total</span>
          </div>
          <div className="projects-stat-divider" />
          <div className="projects-stat">
            <span className="projects-stat-num stat-active">{activeCount}</span>
            <span className="projects-stat-label">Active</span>
          </div>
          <div className="projects-stat-divider" />
          <div className="projects-stat">
            <span className="projects-stat-num stat-inactive">{inactiveCount}</span>
            <span className="projects-stat-label">Inactive</span>
          </div>
          <div className="projects-stat-divider" />
          <div className="projects-stat">
            <span className="projects-stat-num stat-purple">US</span>
            <span className="projects-stat-label">Region</span>
          </div>
        </div>

        {showCreate && (
          <div className="create-project-panel">
            <div className="create-project-header">
              <h3>New Project</h3>
              <div className="mode-toggle">
                <button className={'mode-btn ' + (mode==='ai'?'active':'')} onClick={() => setMode('ai')}>AI Fill</button>
                <button className={'mode-btn ' + (mode==='manual'?'active':'')} onClick={() => setMode('manual')}>Manual</button>
              </div>
            </div>
            {mode === 'ai' && (
              <div className="ai-mode">
                <textarea className="ai-prompt-input" placeholder="Describe your project in plain English" value={aiPrompt} onChange={e => setAiPrompt(e.target.value)} rows={3} />
                <button className="btn-primary" onClick={generateProjectFromAI} disabled={aiLoading || !aiPrompt}>{aiLoading ? 'Generating...' : 'Generate Details'}</button>
              </div>
            )}
            {mode === 'manual' && (
              <div className="manual-form">
                <div className="form-grid">
                  <div className="form-field"><label>Job ID *</label><input placeholder="HCG-005" value={form.jobId} onChange={e => setForm({...form, jobId: e.target.value})} /></div>
                  <div className="form-field"><label>Project Name *</label><input placeholder="Austin Medical Center" value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
                  <div className="form-field"><label>Location *</label><input placeholder="Austin, TX" value={form.location} onChange={e => setForm({...form, location: e.target.value})} /></div>
                  <div className="form-field"><label>Project Type *</label><select value={form.projectType} onChange={e => setForm({...form, projectType: e.target.value})}><option value="">Select</option>{projectTypes.map(t => <option key={t}>{t}</option>)}</select></div>
                  <div className="form-field"><label>Building Type *</label><input placeholder="Office Tower" value={form.buildingType} onChange={e => setForm({...form, buildingType: e.target.value})} /></div>
                  <div className="form-field"><label>Subtype *</label><input placeholder="Class A" value={form.subtype} onChange={e => setForm({...form, subtype: e.target.value})} /></div>
                  <div className="form-field"><label>Start Date *</label><input type="date" value={form.startDate} onChange={e => setForm({...form, startDate: e.target.value})} /></div>
                  <div className="form-field"><label>End Date *</label><input type="date" value={form.endDate} onChange={e => setForm({...form, endDate: e.target.value})} /></div>
                  <div className="form-field"><label>Project Manager *</label><input placeholder="Sarah Johnson" value={form.projectManager} onChange={e => setForm({...form, projectManager: e.target.value})} /></div>
                  <div className="form-field"><label>Site Phone *</label><input placeholder="+1 (512) 555-0100" value={form.sitePhone} onChange={e => setForm({...form, sitePhone: e.target.value})} /></div>
                  <div className="form-field"><label>Site Area (sqft) *</label><input placeholder="50000" value={form.siteArea} onChange={e => setForm({...form, siteArea: e.target.value})} /></div>
                </div>
                <button className="btn-primary" onClick={handleCreate}>Create Project</button>
              </div>
            )}
          </div>
        )}

        <div className="projects-grid">
          {MOCK_PROJECTS.map(p => (
            <div key={p.id} className="project-card" onClick={() => onSelect(p)}>
              <div className="project-card-top">
                <span className={'project-status ' + p.status.toLowerCase()}>{p.status}</span>
                <span className="project-id">{p.id}</span>
              </div>
              <h3 className="project-name">{p.name}</h3>
              <p className="project-location">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                {p.location}
              </p>
              <div className="project-open">Open project →</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Dashboard({ user, project, onBack }) {
  const [activeModule, setActiveModule] = useState(null);
  const [expandedGroup, setExpandedGroup] = useState(null);
  const currentItem = SIDEBAR_MODULES.flatMap(m => m.items).find(i => i.id === activeModule);
  const currentGroup = SIDEBAR_MODULES.find(m => m.items.some(i => i.id === activeModule));

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-brand"><div className="brand-logo small"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div><span className="sidebar-brand-name">DataForge</span></div>
        <div className="sidebar-project-ctx">
          <div className="sidebar-project-label">Current project</div>
          <div className="sidebar-project-name">{project.name}</div>
          <div className="sidebar-project-id">{project.id || '—'} · {project.location}</div>
        </div>
        <nav className="sidebar-nav">
          <div className={'sidebar-nav-item ' + (!activeModule ? 'active' : '')} onClick={() => setActiveModule(null)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
            Overview
          </div>
          {SIDEBAR_MODULES.map(mod => (
            <div key={mod.id}>
              <div className={'sidebar-group-header ' + (expandedGroup === mod.id || mod.items.some(i => i.id === activeModule) ? 'open' : '')} onClick={() => setExpandedGroup(expandedGroup === mod.id ? null : mod.id)}>
                <span className="sidebar-group-icon">{mod.icon}</span>
                <span className="sidebar-group-name">{mod.name}</span>
                <svg className="sidebar-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
              {(expandedGroup === mod.id || mod.items.some(i => i.id === activeModule)) && (
                <div className="sidebar-children">
                  {mod.items.map(item => (<div key={item.id} className={'sidebar-child ' + (activeModule === item.id ? 'active' : '')} onClick={() => setActiveModule(item.id)}>{item.name}</div>))}
                </div>
              )}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{user.name[0]}</div>
            <div className="sidebar-user-info"><span className="sidebar-user-name">{user.name}</span><span className="sidebar-user-role">{user.role}</span></div>
          </div>
          <button className="sidebar-signout" onClick={() => window.location.reload()} title="Sign out"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></button>
        </div>
      </aside>
      <main className="dash-main">
        <div className="dash-topbar">
          <div className="dash-breadcrumb">
            <span className="back-btn" onClick={onBack}>← Projects</span>
            <span className="bc-sep">/</span><span className="bc-item">{project.name}</span>
            {activeModule && (<><span className="bc-sep">/</span><span className="bc-item active">{currentItem?.name}</span></>)}
          </div>
          <span className="topbar-badge"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>{project.location}</span>
        </div>
        <div className="dash-body">
          {!activeModule ? <OverviewPanel project={project} onSelect={setActiveModule} /> : activeModule === 'rfi' ? <RFIModule project={project} /> : <GenericModule moduleId={activeModule} moduleName={currentItem?.name} moduleGroup={currentGroup} project={project} />}
        </div>
      </main>
    </div>
  );
}

function OverviewPanel({ project, onSelect }) {
  return (
    <div className="overview">
      <div className="overview-hero">
        <div className="overview-hero-left">
          <span className={'project-status ' + (project.status || 'active').toLowerCase()}>{project.status || 'Active'}</span>
          <h2 className="overview-project-name">{project.name}</h2>
          <div className="overview-meta">
            <span><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>{project.location}</span>
            {project.id && <span>ID: {project.id}</span>}
            {project.projectManager && <span>PM: {project.projectManager}</span>}
            {project.siteArea && <span>{parseInt(project.siteArea).toLocaleString()} sqft</span>}
          </div>
        </div>
        <div className="overview-hero-right">
          <div className="overview-stat"><span className="ov-stat-label">Start</span><span className="ov-stat-val">{project.startDate || 'Not set'}</span></div>
          <div className="overview-stat"><span className="ov-stat-label">End</span><span className="ov-stat-val">{project.endDate || 'Not set'}</span></div>
          <div className="overview-stat"><span className="ov-stat-label">Type</span><span className="ov-stat-val">{project.buildingType || 'N/A'}</span></div>
        </div>
      </div>
      <div className="overview-section-label">Select a module to generate data</div>
      <div className="overview-grid">{SIDEBAR_MODULES.map(mod => <ModuleCard key={mod.id} mod={mod} onSelect={onSelect} />)}</div>
    </div>
  );
}

function RFIModule({ project }) {
  const [activeTab, setActiveTab] = useState('ai');
  const [prompt, setPrompt] = useState('');
  const [rfiRecord, setRfiRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(null);
  const [history, setHistory] = useState([]);
  const [uploadedRows, setUploadedRows] = useState(null);
  const [bulkResults, setBulkResults] = useState(null);
  const [bulkRunning, setBulkRunning] = useState(false);

  const generateRFI = async () => {
    if (!prompt) return;
    setLoading(true); setRfiRecord(null); setSubmitted(null);
    try {
      const text = await callAI('You are a construction RFI assistant for the project "' + project.name + '" in ' + project.location + '. Based on: "' + prompt + '" generate a single RFI. Return ONLY valid JSON: {"rfiTitle":"string","rfiType":"one of: Design Clarification, Structural Query, MEP Coordination, Site Condition, Material Substitution, Code Compliance, Schedule Impact, Scope Clarification","question":"detailed formal RFI question 2-3 sentences"}');
      setRfiRecord(JSON.parse(text));
    } catch { alert('Error generating RFI. Please try again.'); }
    setLoading(false);
  };

  const handleApprove = async () => {
    if (!rfiRecord) return;
    setSubmitting(true);
    try {
      const result = await mockLinarcAPI(rfiRecord);
      const entry = { ...rfiRecord, linarcId: result.id, date: new Date().toLocaleString(), prompt };
      setHistory(h => [entry, ...h]); setSubmitted(entry); setRfiRecord(null); setPrompt('');
    } catch (err) { alert('API error: ' + err.message); }
    setSubmitting(false);
  };

  const downloadTemplate = () => {
    const csv = 'RFI Title,RFI Type,Question\n"Example title","Design Clarification","Example question"\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'rfi_template.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  const handleFileUpload = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const lines = e.target.result.split('\n').filter(l => l.trim());
      const rows = lines.slice(1).map(line => {
        const parts = line.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/).map(c => c.replace(/^"|"$/g, '').trim());
        return { rfiTitle: parts[0] || '', rfiType: parts[1] || '', question: parts[2] || '', status: 'pending' };
      }).filter(r => r.rfiTitle);
      setUploadedRows(rows); setBulkResults(null);
    };
    reader.readAsText(file);
  };

  const runBulkUpload = async () => {
    if (!uploadedRows) return;
    setBulkRunning(true);
    const results = [];
    for (let i = 0; i < uploadedRows.length; i++) {
      try { const res = await mockLinarcAPI(uploadedRows[i]); results.push({ ...uploadedRows[i], status: 'success', linarcId: res.id }); }
      catch (err) { results.push({ ...uploadedRows[i], status: 'failed', error: err.message }); }
      setBulkResults([...results]);
    }
    setBulkRunning(false);
  };

  const successCount = bulkResults ? bulkResults.filter(r => r.status === 'success').length : 0;
  const failedCount = bulkResults ? bulkResults.filter(r => r.status === 'failed').length : 0;

  return (
    <div className="module-view">
      <div className="module-view-header">
        <div className="module-view-title-row">
          <div className="module-icon-wrap"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>
          <div><h2 className="module-view-title">RFI</h2><p className="module-view-sub">{project.name} · Requests for Information</p></div>
        </div>
        {history.length > 0 && <div className="module-kpi"><span className="kpi-num">{history.length}</span><span className="kpi-label">submitted</span></div>}
      </div>
      <div className="module-tabs">
        <button className={'module-tab ' + (activeTab==='ai'?'active':'')} onClick={() => { setActiveTab('ai'); setSubmitted(null); }}>AI Generate</button>
        <button className={'module-tab ' + (activeTab==='import'?'active':'')} onClick={() => setActiveTab('import')}>Bulk Import</button>
        <button className={'module-tab ' + (activeTab==='history'?'active':'')} onClick={() => setActiveTab('history')}>History {history.length > 0 && <span className="tab-badge">{history.length}</span>}</button>
      </div>
      {activeTab === 'ai' && (
        <div className="tab-content">
          {submitted ? (
            <div className="rfi-success">
              <div className="rfi-success-icon"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div>
              <div className="rfi-success-body"><h3>RFI created in Linarc</h3><p>Record ID: <strong>{submitted.linarcId}</strong></p></div>
              <div className="rfi-success-detail">
                <div className="rfi-field-row"><span className="rfi-field-label">Title</span><span className="rfi-field-val">{submitted.rfiTitle}</span></div>
                <div className="rfi-field-row"><span className="rfi-field-label">Type</span><span className="rfi-field-val"><span className="rfi-type-badge">{submitted.rfiType}</span></span></div>
                <div className="rfi-field-row"><span className="rfi-field-label">Question</span><span className="rfi-field-val">{submitted.question}</span></div>
              </div>
              <button className="btn-outline" onClick={() => setSubmitted(null)}>Create Another RFI</button>
            </div>
          ) : (
            <>
              <div className="example-chips-row">
                <span className="example-label">Try an example:</span>
                <div className="example-chips">{EXAMPLE_PROMPTS.rfi.map((ex, i) => <div key={i} className="example-chip" onClick={() => setPrompt(ex)}>{ex}</div>)}</div>
              </div>
              <div className="rfi-prompt-block">
                <label className="field-label">Describe the RFI you want to create</label>
                <textarea className="rfi-textarea" placeholder="e.g. We need clarification on the structural steel connection details..." value={prompt} onChange={e => setPrompt(e.target.value)} rows={4} />
                <button className="btn-primary" onClick={generateRFI} disabled={loading || !prompt}>{loading ? 'Generating...' : 'Generate RFI'}</button>
              </div>
              {loading && <div className="rfi-skeleton"><div className="skeleton-bar w60"/><div className="skeleton-bar w40"/><div className="skeleton-bar w80"/></div>}
              {rfiRecord && (
                <div className="rfi-card">
                  <div className="rfi-card-header"><span className="rfi-card-label">Review & edit before submitting to Linarc</span><span className="rfi-preview-badge">Preview</span></div>
                  <div className="rfi-fields">
                    <div className="rfi-field-group"><label className="field-label">RFI Title</label><input className="rfi-input" value={rfiRecord.rfiTitle} onChange={e => setRfiRecord({...rfiRecord, rfiTitle: e.target.value})} /></div>
                    <div className="rfi-field-group"><label className="field-label">RFI Type</label><select className="rfi-select" value={rfiRecord.rfiType} onChange={e => setRfiRecord({...rfiRecord, rfiType: e.target.value})}>{RFI_TYPES.map(t => <option key={t}>{t}</option>)}</select></div>
                    <div className="rfi-field-group full"><label className="field-label">Question</label><textarea className="rfi-textarea" value={rfiRecord.question} onChange={e => setRfiRecord({...rfiRecord, question: e.target.value})} rows={4} /></div>
                  </div>
                  <div className="rfi-card-actions">
                    <button className="btn-ghost" onClick={() => setRfiRecord(null)}>Discard</button>
                    <button className="btn-success" onClick={handleApprove} disabled={submitting}>{submitting ? 'Submitting...' : 'Approve & Create in Linarc'}</button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
      {activeTab === 'import' && (
        <div className="tab-content">
          <div className="import-instructions">
            <div className="import-step"><div className="import-step-num">1</div><div><h4>Download the template</h4><p>Fill in RFI Title, RFI Type, and Question columns. Each row = one RFI.</p></div><button className="btn-outline" onClick={downloadTemplate}>Download Template</button></div>
            <div className="import-step"><div className="import-step-num">2</div><div><h4>Upload your filled file</h4><p>Supports CSV. We will preview all records before sending to Linarc.</p></div></div>
            <div className="import-step"><div className="import-step-num">3</div><div><h4>Bulk push to Linarc</h4><p>Each row is submitted individually via the Linarc API with success/failure per record.</p></div></div>
          </div>
          <DropZone onFile={handleFileUpload} />
          {uploadedRows && !bulkResults && (
            <div className="import-preview">
              <div className="import-preview-header"><span><strong>{uploadedRows.length}</strong> records ready</span><button className="btn-success" onClick={runBulkUpload} disabled={bulkRunning}>{bulkRunning ? 'Uploading...' : 'Push ' + uploadedRows.length + ' RFIs to Linarc'}</button></div>
              <div className="rfi-import-table-wrap"><table className="rfi-import-table"><thead><tr><th>#</th><th>RFI Title</th><th>RFI Type</th><th>Question</th></tr></thead><tbody>{uploadedRows.map((row, i) => (<tr key={i}><td className="row-num">{i+1}</td><td>{row.rfiTitle}</td><td><span className="rfi-type-badge">{row.rfiType}</span></td><td className="question-cell">{row.question}</td></tr>))}</tbody></table></div>
            </div>
          )}
          {bulkResults && (
            <div className="bulk-results">
              <div className="bulk-results-summary">
                <div className="bulk-kpi success"><span className="bulk-kpi-num">{successCount}</span><span className="bulk-kpi-label">Created</span></div>
                <div className="bulk-kpi failed"><span className="bulk-kpi-num">{failedCount}</span><span className="bulk-kpi-label">Failed</span></div>
                <div className="bulk-kpi total"><span className="bulk-kpi-num">{bulkResults.length}</span><span className="bulk-kpi-label">Total</span></div>
              </div>
              <div className="rfi-import-table-wrap"><table className="rfi-import-table"><thead><tr><th>#</th><th>RFI Title</th><th>Type</th><th>Linarc ID</th><th>Status</th></tr></thead><tbody>{bulkResults.map((row, i) => (<tr key={i} className={row.status}><td className="row-num">{i+1}</td><td>{row.rfiTitle}</td><td><span className="rfi-type-badge">{row.rfiType}</span></td><td className="mono">{row.linarcId || '—'}</td><td>{row.status==='success' ? <span className="status-pill success">Created</span> : row.status==='failed' ? <span className="status-pill failed">{row.error}</span> : <span className="status-pill pending">...</span>}</td></tr>))}</tbody></table></div>
              {!bulkRunning && <button className="btn-outline" style={{margin:'16px 20px'}} onClick={() => { setUploadedRows(null); setBulkResults(null); }}>Import Another File</button>}
            </div>
          )}
        </div>
      )}
      {activeTab === 'history' && (
        <div className="tab-content">
          {history.length === 0 ? <div className="empty-state"><p>No RFIs created yet</p><span>Records created via AI Generate will appear here</span></div> : (
            <div className="history-list">
              {history.map((item, i) => (
                <div key={i} className="history-item">
                  <div className="history-item-left"><span className="status-pill success">Created</span><div><p className="history-title">{item.rfiTitle}</p><p className="history-meta">{item.linarcId} · {item.rfiType} · {item.date}</p></div></div>
                  <div className="history-question">{item.question}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function DropZone({ onFile }) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef();
  return (
    <div className={'dropzone ' + (dragOver ? 'drag-over' : '')} onDragOver={e => { e.preventDefault(); setDragOver(true); }} onDragLeave={() => setDragOver(false)} onDrop={e => { e.preventDefault(); setDragOver(false); onFile(e.dataTransfer.files[0]); }} onClick={() => inputRef.current.click()}>
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
      <p className="dropzone-text">Drag & drop your CSV here, or <span className="dropzone-link">click to browse</span></p>
      <input ref={inputRef} type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}} onChange={e => onFile(e.target.files[0])} />
    </div>
  );
}

function GenericModule({ moduleId, moduleName, moduleGroup, project }) {
  const [activeTab, setActiveTab] = useState('ai');
  const [prompt, setPrompt] = useState('');
  const [generatedData, setGeneratedData] = useState(null);
  const [uploadedData, setUploadedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successCount, setSuccessCount] = useState(0);

  const generateData = async () => {
    if (!prompt || !moduleId) return;
    setLoading(true);
    const columns = MODULE_COLUMNS[moduleId] || [];
    try {
      const text = await callAI('Generate realistic demo data for the "' + moduleId + '" module for project "' + project.name + '" in ' + project.location + '. Prompt: "' + prompt + '". Columns: ' + columns.join(', ') + '. Return ONLY valid JSON: {"columns":' + JSON.stringify(columns) + ',"rows":[["val1","val2"]]}. Generate 8-10 rows.');
      setGeneratedData(JSON.parse(text));
    } catch { alert('Error generating data. Please try again.'); }
    setLoading(false);
  };

  const handleApprove = () => {
    const data = generatedData || uploadedData;
    if (!data) return;
    setHistory(h => [{ prompt: prompt || 'Manual upload', date: new Date().toLocaleString(), records: data.rows.length, data }, ...h]);
    setSuccessCount(data.rows.length); setGeneratedData(null); setUploadedData(null); setShowSuccess(true);
  };

  const downloadCSV = (data) => {
    const csv = data.columns.join(',') + '\n' + data.rows.map(r => r.map(c => '"' + c + '"').join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = moduleId + '_data.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  const downloadTemplate = () => {
    const csv = (MODULE_COLUMNS[moduleId] || []).join(',');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = moduleId + '_template.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  const handleFileUpload = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      const lines = e.target.result.split('\n').filter(l => l.trim());
      const columns = lines[0].split(',').map(c => c.trim().replace(/"/g, ''));
      const rows = lines.slice(1).map(l => l.split(',').map(c => c.trim().replace(/"/g, '')));
      setUploadedData({ columns, rows });
    };
    reader.readAsText(file);
  };

  return (
    <div className="module-view">
      <div className="module-view-header">
        <div className="module-view-title-row"><div className="module-icon-wrap">{moduleGroup?.icon}</div><div><h2 className="module-view-title">{moduleName}</h2><p className="module-view-sub">{project.name}</p></div></div>
        <div className="module-kpi"><span className="kpi-num">{generatedData ? generatedData.rows.length : uploadedData ? uploadedData.rows.length : 0}</span><span className="kpi-label">records</span></div>
      </div>
      <div className="module-tabs">
        <button className={'module-tab ' + (activeTab==='ai'?'active':'')} onClick={() => setActiveTab('ai')}>AI Generate</button>
        <button className={'module-tab ' + (activeTab==='upload'?'active':'')} onClick={() => setActiveTab('upload')}>Upload</button>
        <button className={'module-tab ' + (activeTab==='history'?'active':'')} onClick={() => setActiveTab('history')}>History {history.length > 0 && <span className="tab-badge">{history.length}</span>}</button>
      </div>
      {activeTab === 'ai' && (
        <div className="tab-content">
          {showSuccess ? (
            <div className="generic-success">
              <div className="success-icon-wrap"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div>
              <h3>Data uploaded successfully</h3><p>{successCount} records added to {moduleName}</p>
              <div className="success-actions">
                <button className="btn-outline" onClick={() => { setShowSuccess(false); setActiveTab('history'); }}>View History</button>
                <button className="btn-primary" onClick={() => { setShowSuccess(false); setPrompt(''); }}>Generate More</button>
              </div>
            </div>
          ) : (
            <>
              {EXAMPLE_PROMPTS[moduleId] && <div className="example-chips-row"><span className="example-label">Try an example:</span><div className="example-chips">{EXAMPLE_PROMPTS[moduleId].map((ex, i) => <div key={i} className="example-chip" onClick={() => setPrompt(ex)}>{ex}</div>)}</div></div>}
              <div className="rfi-prompt-block">
                <label className="field-label">Describe the {moduleName} data you want to generate</label>
                <textarea className="rfi-textarea" placeholder={'What data do you need for ' + moduleName + '?'} value={prompt} onChange={e => setPrompt(e.target.value)} rows={4} />
                <button className="btn-primary" onClick={generateData} disabled={loading || !prompt}>{loading ? 'Generating...' : 'Generate Data'}</button>
              </div>
              {generatedData && (
                <div className="table-wrap">
                  <div className="table-wrap-header"><span>{generatedData.rows.length} records generated</span><div className="table-wrap-actions"><button className="btn-outline" onClick={() => downloadCSV(generatedData)}>Download CSV</button><button className="btn-success" onClick={handleApprove}>Approve & Upload</button></div></div>
                  <div className="table-scroll"><table className="data-table"><thead><tr>{generatedData.columns.map((c, i) => <th key={i}>{c}</th>)}</tr></thead><tbody>{generatedData.rows.map((row, i) => <tr key={i}>{row.map((cell, j) => <td key={j}>{cell}</td>)}</tr>)}</tbody></table></div>
                </div>
              )}
            </>
          )}
        </div>
      )}
      {activeTab === 'upload' && (
        <div className="tab-content">
          <div className="import-step standalone"><div className="import-step-num">1</div><div><h4>Download template</h4><p>Get the CSV template with correct column headers for {moduleName}.</p></div><button className="btn-outline" onClick={downloadTemplate}>Download Template</button></div>
          <DropZone onFile={handleFileUpload} />
          {uploadedData && (
            <div className="table-wrap">
              <div className="table-wrap-header"><span>{uploadedData.rows.length} records ready</span><button className="btn-success" onClick={handleApprove}>Approve & Upload</button></div>
              <div className="table-scroll"><table className="data-table"><thead><tr>{uploadedData.columns.map((c, i) => <th key={i}>{c}</th>)}</tr></thead><tbody>{uploadedData.rows.map((row, i) => <tr key={i}>{row.map((cell, j) => <td key={j}>{cell}</td>)}</tr>)}</tbody></table></div>
            </div>
          )}
        </div>
      )}
      {activeTab === 'history' && (
        <div className="tab-content">
          {history.length === 0 ? <div className="empty-state"><p>No history yet</p></div> : (
            <div className="history-list">
              {history.map((item, i) => (
                <div key={i} className="history-item">
                  <div className="history-item-left"><span className="status-pill success">Done</span><div><p className="history-title">"{item.prompt}"</p><p className="history-meta">{item.date} · {item.records} records</p></div></div>
                  <div className="history-actions"><button className="btn-ghost small" onClick={() => { setGeneratedData(item.data); setActiveTab('ai'); }}>View</button><button className="btn-ghost small" onClick={() => { setPrompt(item.prompt); setActiveTab('ai'); }}>Re-use</button></div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}